import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { maxBy, keys } from 'lodash'
import SplitOrderByItems from '../../../components/tabs/OrderDetailsModal/SplitOrderByItems'

import { makeGetTabOrder } from '../../../selectors/order'
import { makeGetDisplaySuiteByOrder } from '../../../selectors/suites'

import { TabOrderDetailsViewModel } from '../../../viewmodels/TabOrderViewModel'

import { centsToDollars } from '../../../utils/formatters'
import { getRemoteOrderTotal } from '../../../actions/orderTotalRemote'

const itemGroupings = (items) => {
  const result = items.reduce((items, item, index) => {
    const identifier = item.id + item.modifiersString + item.price
    const itemWithIndex = {
      ...item,
      originalIndex: index,
    }

    const itemGrouping = {
      name: item.name,
      id: item.id,
      quantity: 1,
      price: centsToDollars(item.priceInCents),
      priceInCents: item.priceInCents,
      modifiersString: item.modifiersString,
      items: [ itemWithIndex ],
    }

    if (items[identifier] !== undefined) {
      items[identifier].quantity += 1
      items[identifier].priceInCents += item.priceInCents
      items[identifier].price = centsToDollars(items[identifier].priceInCents)
      items[identifier].items.push(itemWithIndex)

    } else {
      items[identifier] = itemGrouping
    }

    return items
  }, {})

  keys(result).forEach((identifier) => {
    const group = result[identifier]

    const modifiersSubtotal = group.items.reduce((sum, item) => {
      const itemModifiers = item?.modifiers ?? []

      return sum + itemModifiers.reduce((acc, modifier) => {
        return acc + modifier?.defaultPriceInCents ?? 0
      }, 0)
    }, 0)

    const subtotal = group.priceInCents + modifiersSubtotal

    group.priceInCents = subtotal
    group.price = centsToDollars(subtotal)
  })

  return result
}

const mapStateToProps = (state, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const getTabOrder = makeGetTabOrder()
  const getDisplaySuite = makeGetDisplaySuiteByOrder()
  const suiteInformation = getDisplaySuite(state, orderId)
  const tabOrder = getTabOrder(state, orderId)
  const order = TabOrderDetailsViewModel(tabOrder)
  const remoteOrderTotal = maxBy([order.orderTotalFromOrder, order.remoteOrderTotal], 'updatedAt') || {}

  const customerId = order?.customerId ?? ''
  const revenueCenterId = order?.revenueCenterUuid ?? ''
  const isOrderLatestFromServer = tabOrder?.latestFromServer ?? false

  return {
    ...order,
    customerId,
    isOrderLatestFromServer,
    remoteOrderTotal,
    revenueCenterId,
    suiteInformation,
    itemGroupings: itemGroupings(order.items),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = ownProps?.match?.params?.orderId ?? ''
  const replace = ownProps?.history?.replace ?? function(){}

  return {
    onClose: () => replace('/tabs'),
    onConfirmItems: (selectedItemIndexes, items) => {

      dispatch(getRemoteOrderTotal({ orderUuid: orderId, splitOrder: true, items }))
      replace({
        pathname: `/tabs/${orderId}/close`,
        state: {
          selectedItemIndexes,
          splitOrderType: 'tab',
        },
      })
    },
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SplitOrderByItems))
